module.exports = __webpack_public_path__ + "static/media/whatsapp_voice.394f61d0.svg";